export default "__VITE_ASSET__Bej92NPq__"